module.exports = __webpack_public_path__ + "static/idc-9538c8d25d6ad743195fbc6ed1873aa2.jpg";